<template>
  <Layout>
    <h2 class="py-4">{{ formTitle }}</h2>
    <h3 class="pb-4">User Basic Information</h3>
    <div class="w-full lg:w-1/2 pt-4">
      <div v-if="!isEditForm">
        <p class="pb-4">User Type</p>
        <pt-select
          v-model="adminType"
          :allow-empty="false"
          :options="adminTypes"
          track-by="id"
          label-key="label"
          class="mb-4"
          @select="onAdminTypeChange"
        />
      </div>

      <pt-form-group
        v-if="shouldShowRestaurantId"
        :invalid-feedback="formErrors.restaurantID"
        label="Restaurant ID *"
        label-for="restaurant"
        class="mb-4"
      >
        <pt-form-input
          id="restaurant"
          v-model="$v.restaurantID.$model"
          type="text"
          placeholder="Enter restaurant ID..."
        />
      </pt-form-group>
      <pt-form-group
        :invalid-feedback="formErrors.restoName"
        label="Restaurant Name *"
        label-for="name"
        class="mb-4"
      >
        <pt-form-input
          id="name"
          v-model="$v.restoName.$model"
          type="text"
          placeholder="Enter name..."
        />
      </pt-form-group>

      <p class="pb-4">Phone</p>
      <pt-form-input
        id="phone"
        v-model="phone"
        class="pb-4"
        type="text"
        placeholder="Enter phone..."
      />

      <pt-form-group
        :invalid-feedback="formErrors.email"
        label="Email *"
        label-for="email"
        class="mb-4"
      >
        <pt-form-input
          id="email"
          v-model="$v.email.$model"
          type="text"
          placeholder="Enter email..."
        />
      </pt-form-group>

      <pt-form-group
        :invalid-feedback="formErrors.password"
        label="Password *"
        label-for="password"
        class="mb-4"
      >
        <pt-form-input
          id="password"
          v-model="$v.password.$model"
          type="password"
          placeholder="Enter password..."
        />
      </pt-form-group>

      <p class="pb-4">Address</p>
      <pt-form-input
        id="address"
        v-model="address"
        type="text"
        placeholder="Enter address..."
      />
    </div>
    <h3 class="py-8">Upload Profile Image</h3>
    <input
      class="user-img"
      type="file"
      accept="image/*"
      @change="handleFileUpload"
    />
    <div class="pt-4 flex">
      <img
        ref="profilePic"
        src=""
        class="preview"
      />
      <!-- <i
        v-if="files.length > 0"
        class="fa fa-remove pl-2 cursor-pointer"
        @click="removeImage"
      /> -->
    </div>

    <div
      v-if="adminType && adminType.id === 1"
      class="flex flex-col flex-1"
    >
      <h3 class="py-8">Roles</h3>
      <div class="w-full lg:w-1/2">
        <div class="flex flex-wrap">
          <div
            v-for="role in roles"
            :key="role.id"
            class="w-1/2 lg:w-1/3 pb-4"
          >
            <input
              v-model="checkedRoles"
              :value="role.id"
              :id="'role-'+role.id"
              type="checkbox"
            />
            <label :for="'role-'+role.id" class="pl-2">{{ role.name }}</label>
          </div>
        </div>
      </div>
      <h3 class="py-8">Permissions</h3>
      <div class="w-full lg:w-1/2">
        <div class="flex flex-wrap">
          <div
            v-for="perm in permissions"
            :key="perm.id"
            class="w-1/2 lg:w-1/3 pb-4"
          >
            <input
              v-model="checkedPerms"
              :value="perm.id"
              :id="'perm-'+perm.id"
              type="checkbox"
            />
            <label :for="'perm-'+perm.id" class="pl-2">{{ perm.name }}</label>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="flex flex-col"
    >
      <div class="flex sm:w-full lg:w-1/2 py-4 my-4 items-center border-b border-grey">
        <div class="font-bold mr-2 flex-1">Restaurants</div>
        <pt-button
          variant="primary-outline"
          @action="showRestaurantSelectionModal"
        >Add More</pt-button>
      </div>
      <div class="flex sm:w-full lg:w-1/2">
        <pt-list v-if="selectedRestaurants.length">
          <pt-list-item
            v-for="restaurant in selectedRestaurants"
            :key="restaurant.resto_id"
          >
            <div class="flex flex-1">
              <div class="flex-col flex-1 h-8">
                <div class="mb-2">{{ restaurant.restaurant_name }}</div>
                <div class="italic text-grey-dark">{{ restaurant.resto_id }}</div>
              </div>
              <div
                class="rounded-full w-8 h-8 flex items-center justify-center bg-red text-white"
                @click="removeRestaurantFromSelectedList(restaurant)"
              >
                <i class="fa fa-trash-o" />
              </div>
            </div>
          </pt-list-item>
        </pt-list>
        <p v-else>No Data Found</p>
      </div>
    </div>

    <div class="w-1/2 lg:w-1/6 pb-16">
      <pt-button
        :disabled="submitting"
        :is-full-width="true"
        variant="primary"
        class="mt-4"
        @action="submit"
      >
        {{ submitting ? 'Submitting...' : 'Submit' }}
      </pt-button>
    </div>
    <pt-modal
      ref="restaurantSearchModal"
      size="medium"
      @onOpen="onModalOpened"
    >
      <div slot="modal-body">
        <pt-form-input
          v-model="searchKey"
          placeholder="Search restaurant"
          icon-class="text-grey fa-search"
          icon-position="left"
          type="text"
          class="mb-4"
          @input="getSearchedRestaurants"
        />
        <pt-list
          v-if="filteredRestaurantSearchList.length"
          class="resto-search-list"
        >
          <pt-list-item
            v-for="restaurant in filteredRestaurantSearchList"
            :key="restaurant.id"
            @list-item-clicked="addRestaurantToSelectedList(restaurant)"
          >
            <div class="flex flex-1 flex-col">
              <div class="mb-2">{{ restaurant.restaurant_name }}</div>
              <div class="italic text-grey-dark">{{ restaurant.id }}</div>
            </div>
            <div class="w-6 h-6 bg-green text-white rounded-full flex items-center justify-center">
              <i class="fa fa-plus" />
            </div>
          </pt-list-item>
        </pt-list>
        <p v-else>No Data Found</p>
      </div>
    </pt-modal>
  </Layout>
</template>

<script>
import Layout from '@layouts/main';
import { PtButton } from '@pathao/ui-components/esm/Button';
import { PtSelect } from '@pathao/ui-components/esm/Select';
import { PtFormInput, PtFormGroup, PtFormCheckbox } from '@pathao/ui-components/esm/FormComponents';
import { PtList, PtListItem } from '@pathao/ui-components/esm/List';
import { PtModal } from '@pathao/ui-components/esm/Modal';
import { required, email } from 'vuelidate/lib/validators';
import { ROLE_LIST, PERMISSION_LIST, ADMIN_USER, CREATE_USER, ADMIN_RESTAURANT_LIST, ADMIN_MANAGE_RESTO } from '@src/config/apiEndpoints';
import apiRequest from '@src/utils/apiRequest';
import config from '@src/config';

const ADMIN_TYPES = [{
  id: 1,
  label: 'User Admin',
}, {
  id: 2,
  label: 'Resto Admin',
}];

const emptyPolicy = (str) => {
  const trimmed = str.trim();

  return Boolean(trimmed);
};

const DEFAULT_PROFILE_IMAGE_PATH = '/img/default-user.3c1dd009.png';

export default {
  name: 'CreateUsers',
  page: {
    title: 'Create users',
  },
  components: {
    Layout,
    PtButton,
    PtFormInput,
    PtFormGroup,
    PtSelect,
    PtListItem,
    PtList,
    PtModal,
    PtFormCheckbox,
  },
  props: {
    userid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      adminTypes: ADMIN_TYPES,
      adminType: {
        id: 1,
        label: 'User Admin',
      },
      formTitle: this.userid ? 'Edit User' : 'Add User',
      restaurantID: '',
      isAdmin: 0,
      restoName: '',
      desc: '',
      address: '',
      password: '',
      email: '',
      phone: '',
      user: {},
      checkedPerms: [],
      checkedRoles: [],
      permissions: [],
      roles: [],
      files: [],
      submitting: false,
      selectedRestaurants: [],
      searchedRestaurants: [],
      searchKey: null,
      shouldShowRestaurantId: Boolean(!this.userid),
    };
  },
  validations: {
    restoName: { required, emptyPolicy },
    email: { required, email, emptyPolicy },
    restaurantID: { required, emptyPolicy },
    password: { required, emptyPolicy },
  },
  computed: {
    formErrors() {
      const errors = {};

      const isUserAdmin = this.adminType && this.adminType.id === 1;
      const hasErrorInName = this.$v.restoName.$dirty && this.$v.restoName.$invalid;
      const hasErrorInRestaurantID = this.$v.restaurantID.$dirty && this.$v.restaurantID.$invalid;
      const hasErrorInEmail = this.$v.email.$dirty && this.$v.email.$invalid;
      const hasErrorInPassword = this.$v.password.$dirty && this.$v.password.$invalid;

      if (hasErrorInName) {
        errors.restoName = 'Please provide a Restaurant name';
      }

      if (hasErrorInEmail) {
        errors.email = 'Please provide a valid email address';
      }

      if (hasErrorInRestaurantID && !this.isEditForm && isUserAdmin) {
        errors.restaurantID = 'Please provide Restaurant ID';
      }

      if (hasErrorInPassword && !this.isEditForm) {
        errors.password = 'Please provide a password';
      }

      return errors;
    },
    isEditForm() {
      return this.userid;
    },
    filteredRestaurantSearchList() {
      if (!this.selectedRestaurants) {
        return this.searchedRestaurants;
      }

      const selectedRestaurantIds = this.selectedRestaurants.map(resto => resto.resto_id);

      return this.searchedRestaurants.filter(restaurant => {
        return selectedRestaurantIds.indexOf(restaurant.id) === -1;
      });
    },
  },
  mounted() {
    this.getPermissions();
    this.getRoles();

    if (this.userid) {
      this.getUser();
    } else {
      this.setProfilePic();
    }
  },
  methods: {
    setProfilePic(imageSrc, isBase64 = false) {
      if (!imageSrc) {
        this.$refs.profilePic.src = DEFAULT_PROFILE_IMAGE_PATH;
      } else {
        this.$refs.profilePic.src = !isBase64 ? `${config.api.imageURL}${imageSrc}` : imageSrc;
      }
    },
    removeImage() {
      this.files = [];
      this.setProfilePic();
      // TODO:
      // POST request
      // payload = {
      //   "id": 35,
      //   "image_name": "uploads/images/profile/31fed17f9c19.jpg"
      // }
    },
    handleFileUpload(event) {
      let file = event.target.files[0];
      // console.log(file);
      this.files = [];
      let reader = new FileReader();

      reader.addEventListener('load', () => {
        this.files.push(reader.result);
        this.setProfilePic(reader.result, true);
        this.$refs.profilePic.src = reader.result;
      }, false);

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    submit() {
      this.submitting = true;
      this.$v.restoName.$touch();
      this.$v.email.$touch();

      const isUserAdmin = this.adminType && this.adminType.id === 1;
      let hasAnyError = this.formErrors.restoName || this.formErrors.email;

      if (isUserAdmin) {
        this.$v.restaurantID.$touch();
        hasAnyError = hasAnyError || this.formErrors.restaurantID;
      }

      if (!this.isEditForm) {
        this.$v.password.$touch();
        hasAnyError = hasAnyError || this.formErrors.password;
      }

      if (hasAnyError) {
        this.submitting = false;
        this.$notification.error('Please provide correct values in all fields');

        return null;
      }

      let payload = {
        url: CREATE_USER,
        method: 'POST',
        data: {
          is_super_user: 0,
          is_resto_admin_user: this.adminType.id !== 1,
          name: this.restoName,
          location: this.address,
          email: this.email,
          password: this.password,
          number: this.phone,
          permissions: this.checkedPerms,
          roles: this.checkedRoles,
          // profile_pic: this.files,
        },
      };

      if (this.adminType.id === 1) {
        payload.data.restaurant_id = this.restaurantID;
      } else {
        payload.data.admin_restaurant_ids = this.selectedRestaurants.map(resto => resto.resto_id);
      }

      if (this.files.length > 0) {
        payload.data.profile_pic = this.files;
      }

      if (this.userid) {
        payload.url = ADMIN_USER + this.userid;
      }
      // console.log(payload);
      apiRequest(payload)
        .then((response) => {
          this.$router.push('/users');
        })
        .catch((error) => {
          if (error.response.data && !error.response.data.success && error.response.data.message) {
            this.$notification.error(error.response.data.message);
          } else {
            this.$notification.error('Failed to create user. May be server is down or so.');
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    getUser() {
      let payload = {
        url: ADMIN_USER + this.userid,
        method: 'GET',
      };
      // console.log(payload);
      apiRequest(payload)
        .then((response) => {
          // console.log(response);
          this.user = response.data.user;
          this.isAdmin = this.user.is_super_user;
          this.restoName = this.user.name;
          this.desc = this.user.description;
          this.address = this.user.address;
          this.email = this.user.email;
          this.phone = this.user.number;
          let roles = response.data.user.roles;
          let permissions = response.data.user.permissions;
          this.checkedRoles = roles.map(role => role.id);
          this.checkedPerms = permissions.map(perm => perm.id);
          this.adminType = this.user.is_resto_admin ? ADMIN_TYPES[1] : ADMIN_TYPES[0];
          this.selectedRestaurants = this.user.admin_restaurant_ids_with_name;
          this.shouldShowRestaurantId = false;

          const profilePic = this.user.profile_pic ? this.user.profile_pic : null;
          this.setProfilePic(profilePic);
        });
    },
    getRoles(userid) {
      let payload = {
        url: ROLE_LIST,
        method: 'GET',
      };
      // console.log(payload);
      apiRequest(payload)
        .then((response) => {
          // console.log(response);
          this.roles = response.data.roles;
        });
    },
    getPermissions() {
      let payload = {
        url: PERMISSION_LIST,
        method: 'GET',
      };
      apiRequest(payload)
        .then((response) => {
          this.permissions = response.data.permissions;
        });
    },
    showRestaurantSelectionModal() {
      this.$refs.restaurantSearchModal.showModal();
    },
    onModalOpened() {
      this.searchKey = '';
      this.searchedRestaurants = [];
      this.getSearchedRestaurants();
    },
    getSearchedRestaurants() {
      const params = {};

      if (this.searchKey) {
        params.restaurant_name = this.searchKey;
      }

      apiRequest({
        url: ADMIN_RESTAURANT_LIST,
        params,
      })
        .then(response => {
          this.searchedRestaurants = response.data.restaurants;
        })
        .catch(err => {
          console.error(err);
        });
    },
    addRestaurantToSelectedList(restaurant) {
      this.selectedRestaurants.push({
        restaurant_name: restaurant.restaurant_name,
        resto_id: restaurant.id,
      });
    },
    removeRestaurantFromSelectedList(removingRestaurant) {
      this.selectedRestaurants = this.selectedRestaurants.filter(restaurant => {
        return removingRestaurant.resto_id !== restaurant.resto_id;
      });
    },
    onAdminTypeChange() {
      let shouldShowID = false;

      if (!this.userid) {
        shouldShowID = this.adminType && this.adminType.id === 1;
      }

      this.shouldShowRestaurantId = shouldShowID;
    },
    setRestaurantOrderAcceptance(restaurant) {
      const url = ADMIN_MANAGE_RESTO.replace(':id', restaurant.id);
      apiRequest({
        url,
        method: 'PATCH',
        data: {
          enable: !restaurant.is_accepting_orders,
        },
      })
        .then(response => {
          if (response.success) {
            this.getUsers();
          } else {
            this.$notification.error(`Couldn't update acceptance status. Please try again`);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>
<style>
  img.preview {
    width: 100px;
    height: 100px;
  }
  .resto-search-list {
    max-height: 300px;
    overflow-y: scroll;
  }
</style>
